<script lang="ts" setup>
import { ThreadsNavInstance } from "@/components/mobile/ThreadsNav.vue";
import { ref } from "vue";
import { goDiscordLink } from "@/use/go";
import { useUI } from "@/stores/ui";

const uiStore = useUI();
</script>
<template>
  <div class="w-full h-full grid grid-rows-[auto_1fr]">
    <threads-nav show-back>
      <template #center>{{ $t("rank.leaderboardRulesExplanation") }}</template>
    </threads-nav>
    <div class="w-full h-full overflow-y-auto flex justify-center p-4">
      <div class="flex flex-col">
        <article
          class="prose prose-sm md:prose-base"
          v-html="$t('rank.rankRulesContent')"
        ></article>
        <div class="divider">End</div>
        <div class="flex flex-col p-8 pt-2 gap-2">
          <div class="text-center text-base text-base-content/50">
            {{ $t("SidebarNavi.feedback") }}
          </div>
          <div class="flex gap-2 justify-center items-center">
            <button
              class="btn btn-primary rounded text-base-content/50 font-normal"
              @click="goDiscordLink"
            >
              <i class="iconfont icon-discord1 text-lg"></i>
              Discord
            </button>
            <button
              class="btn btn-primary rounded text-base-content/50 font-normal"
              @click="uiStore.showWechatDialog = true"
            >
              <i class="iconfont icon-wechat-fill text-2xl" />
              {{ $t("SidebarNavi.wechat") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
